/**
 * 정렬 축 = 언어(S21-b 확정안) — 통역문은 좌측·청록, 원어 그대로는 우측·파랑.
 *
 * 판정은 **카드의 방향 메타데이터**에서만 파생한다 — ko/vi 를 하드코딩하지
 * 않는다(방은 어떤 쌍이든, 양방향이든 될 수 있다 — QueuedUtt 에 발화별로
 * src/dst 가 각인된다 §1-4).
 *
 *  · 실시간 카드: `passthrough` 가 그 판정이다. 서버 verify 가 "화자가
 *    타깃 언어로 말해 통역할 것이 없다" 고 **발화에 각인된 방향**으로
 *    내린 판정이라(§6.5), 카드 본문이 화자의 원어 그대로임을 뜻한다.
 *    passthrough 가 아니면 본문은 번역문이다(양방향 방의 역번역 포함 —
 *    그 카드의 본문도 번역문이므로 같은 쪽이 맞다).
 *  · 긴호흡(문단) 카드: 창의 발화 언어가 **그 방의 타깃**과 같으면 문단은
 *    번역이 아니라 원어의 복원이다. 타깃은 방(카드)이 알려 주는 `dst` 에서
 *    온다 — 예전에는 여기에 'ko' 가 박혀 있었고(DEF-085 A7), 그 탓에 ko→vi
 *    방의 회의록 좌·우 분류가 뒤집혔다.
 */

import type { CaptionFinalData, RecordParagraphData } from './events'

export type CardSide = 'trans' | 'origin'

/** 실시간 확정 카드의 정렬 쪽 — passthrough = 원어 그대로(우측). */
export function finalSide(data: CaptionFinalData): CardSide {
  return data.passthrough ? 'origin' : 'trans'
}

/**
 * 긴호흡 문단 카드의 정렬 쪽 — 창 언어 == 방의 타깃이면 원어 복원(우측).
 *
 * `dst` 는 **방의 타깃**이다(발화 각인값이 카드까지 내려온 것). 비어 있으면
 * 판정할 근거가 없으므로 통역문 쪽으로 둔다 — 없는 판별을 있는 척하지 않는다.
 */
export function paragraphSide(
  data: RecordParagraphData,
  dst: string,
): CardSide {
  return Boolean(dst) && data.lang === dst ? 'origin' : 'trans'
}
